module.exports = __webpack_public_path__ + "static/img/Kim_h5.948cf00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Kim_h5.png
// module id = qv+T
// module chunks = 34